/**
 * Variables the platform derives and passes to the agent at conversation
 * start — always available to the prompt, never declared as custom variables.
 * Mirrors the API's RESERVED_DYNAMIC_VARIABLE_KEYS.
 */
export const PLATFORM_VARIABLES = [
  { key: 'first_name', name: 'First name', detail: 'the invitee’s first name' },
  { key: 'last_name', name: 'Last name', detail: 'the invitee’s last name' },
  { key: 'template_name', name: 'Template name', detail: 'this template’s name' },
  {
    key: 'external_user_id',
    name: 'External user ID',
    detail: 'your user ID from the invite (only when provided)',
  },
  { key: 'session_id', name: 'Session ID', detail: 'the platform session identifier' },
] as const;
